/**
 * Vyhľadávanie — jediná definícia pre API, admin aj mobil.
 *
 * Najkratší hľadaný text. Jeden znak by matchol skoro všetko (sekvenčný sken
 * celej tabuľky, trigram index z neho nič nevytvorí), preto sa s kratším textom
 * nevyhľadáva: admin ho vôbec nepošle (zoznam ostane nefiltrovaný a pole ukáže
 * nápovedu), API naň vráti 200 s prázdnym výsledkom — starší klient (mobil) tak
 * len ukáže prázdny stav. Rovnaké minimum platí aj pre číslice telefónu.
 */
export const SEARCH_MIN_LENGTH = 2

/** Text na vyhľadanie: orezaný a prázdny (= bez filtra), kým nemá aspoň SEARCH_MIN_LENGTH znakov. */
export function searchTerm(raw: string | null | undefined): string {
  const trimmed = raw?.trim() ?? ''
  return trimmed.length >= SEARCH_MIN_LENGTH ? trimmed : ''
}

/** Niečo je napísané, ale na vyhľadanie je to málo (prázdny text nie je krátky — znamená „bez filtra"). */
export function isSearchTooShort(raw: string | null | undefined): boolean {
  const trimmed = raw?.trim() ?? ''
  return trimmed.length > 0 && trimmed.length < SEARCH_MIN_LENGTH
}

const PHONE_LIKE = /^[+\d\s\-().]+$/

/**
 * Dopyt, ktorý vyzerá ako telefón („+421 915 555", „0915-555", „55"), zredukovaný na holé
 * číslice bez predvoľby — medzinárodnej (00), slovenskej (421) aj národnej (0). Uložené čísla
 * bývajú v rôznych tvaroch (+421915…, 0915…, 00421915…) a porovnávajú sa substringom nad
 * číslicami, takže „0915…", „+421 915…" aj „915…" nájdu každý z nich.
 * Null, ak dopyt nie je telefón (obsahuje písmená) alebo ostane menej ako SEARCH_MIN_LENGTH
 * číslic (rovnaké minimum ako text) — „2" či samotné „09" by matchli skoro každé číslo.
 */
export function normalizePhoneSearch(raw: string): string | null {
  const trimmed = raw.trim()
  if (!PHONE_LIKE.test(trimmed) || !/\d/.test(trimmed)) return null
  let digits = trimmed.replace(/\D/g, '')
  if (digits.startsWith('00')) digits = digits.slice(2)
  if (digits.startsWith('421')) digits = digits.slice(3)
  else if (digits.startsWith('0')) digits = digits.slice(1)
  return digits.length >= SEARCH_MIN_LENGTH ? digits : null
}
